var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _vm.$userInfo.isSupportUser ||
    _vm.$userInfo.isCustomerAdministrator ||
    _vm.$userInfo.isSystemAdministrator
      ? _c("div", { staticClass: "tile is-parent pl-1" }, [
          _c("article", { staticClass: "tile is-child box" }, [
            _c(
              "div",
              { staticClass: "columns is-flex is-align-items-center" },
              [
                _vm._m(0),
                !_vm.hasError &&
                _vm.showSavingStatus &&
                !_vm.toastNotificationEnabled
                  ? _c(
                      "div",
                      {
                        staticClass:
                          "column is-flex is-justify-content-flex-end is-align-items-center",
                      },
                      [
                        _vm.saving
                          ? _c("span", {
                              staticClass: "button is-loading is-white",
                              staticStyle: { height: "27px" },
                            })
                          : _c(
                              "span",
                              { staticClass: "text has-text-success" },
                              [
                                _c("span", { staticClass: "mso mso-18px" }, [
                                  _vm._v("check_circle"),
                                ]),
                              ]
                            ),
                        _c(
                          "span",
                          {
                            staticClass: "is-size-6",
                            class: _vm.saving
                              ? "has-text-warning"
                              : "has-text-success",
                          },
                          [_vm._v(_vm._s(_vm.savingStatus))]
                        ),
                      ]
                    )
                  : _vm._e(),
              ]
            ),
            _c("div", { staticClass: "field" }, [
              _c("div", { staticClass: "tabs is-boxed" }, [
                _c(
                  "ul",
                  _vm._l(
                    _vm.companyExternalSettings,
                    function (companyExternalSetting, index) {
                      return _c(
                        "li",
                        {
                          key: index,
                          class: { "is-active": _vm.activeTabIndex === index },
                        },
                        [
                          _c(
                            "a",
                            {
                              on: {
                                click: function ($event) {
                                  _vm.activeTabIndex = index
                                },
                              },
                            },
                            [_vm._v(_vm._s(companyExternalSetting.settingName))]
                          ),
                        ]
                      )
                    }
                  ),
                  0
                ),
              ]),
            ]),
            _vm.activeCompanyExternalSetting
              ? _c("div", { staticClass: "field columns" }, [
                  _c(
                    "div",
                    { staticClass: "column is-half" },
                    _vm._l(_vm.$options.columns.left, function (column, index) {
                      return _c("div", { key: index, staticClass: "field" }, [
                        _c("label", { staticClass: "label" }, [
                          _vm._v(
                            _vm._s(
                              _vm.activeCompanyExternalSetting[column.label]
                            )
                          ),
                        ]),
                        _vm.requirePasswordInvisible(column)
                          ? _c("div", { staticClass: "field has-addons" }, [
                              _c(
                                "div",
                                { staticClass: "control is-expanded" },
                                [
                                  (_vm.showPassword ? "text" : "password") ===
                                  "checkbox"
                                    ? _c("input", {
                                        directives: [
                                          {
                                            name: "model",
                                            rawName: "v-model",
                                            value:
                                              _vm.activeCompanyExternalSetting[
                                                column.value
                                              ],
                                            expression:
                                              "activeCompanyExternalSetting[column.value]",
                                          },
                                        ],
                                        staticClass: "input",
                                        attrs: {
                                          disabled: !_vm.passwordEnabled,
                                          type: "checkbox",
                                        },
                                        domProps: {
                                          checked: Array.isArray(
                                            _vm.activeCompanyExternalSetting[
                                              column.value
                                            ]
                                          )
                                            ? _vm._i(
                                                _vm
                                                  .activeCompanyExternalSetting[
                                                  column.value
                                                ],
                                                null
                                              ) > -1
                                            : _vm.activeCompanyExternalSetting[
                                                column.value
                                              ],
                                        },
                                        on: {
                                          change: function ($event) {
                                            var $$a =
                                                _vm
                                                  .activeCompanyExternalSetting[
                                                  column.value
                                                ],
                                              $$el = $event.target,
                                              $$c = $$el.checked ? true : false
                                            if (Array.isArray($$a)) {
                                              var $$v = null,
                                                $$i = _vm._i($$a, $$v)
                                              if ($$el.checked) {
                                                $$i < 0 &&
                                                  _vm.$set(
                                                    _vm.activeCompanyExternalSetting,
                                                    column.value,
                                                    $$a.concat([$$v])
                                                  )
                                              } else {
                                                $$i > -1 &&
                                                  _vm.$set(
                                                    _vm.activeCompanyExternalSetting,
                                                    column.value,
                                                    $$a
                                                      .slice(0, $$i)
                                                      .concat(
                                                        $$a.slice($$i + 1)
                                                      )
                                                  )
                                              }
                                            } else {
                                              _vm.$set(
                                                _vm.activeCompanyExternalSetting,
                                                column.value,
                                                $$c
                                              )
                                            }
                                          },
                                        },
                                      })
                                    : (_vm.showPassword
                                        ? "text"
                                        : "password") === "radio"
                                    ? _c("input", {
                                        directives: [
                                          {
                                            name: "model",
                                            rawName: "v-model",
                                            value:
                                              _vm.activeCompanyExternalSetting[
                                                column.value
                                              ],
                                            expression:
                                              "activeCompanyExternalSetting[column.value]",
                                          },
                                        ],
                                        staticClass: "input",
                                        attrs: {
                                          disabled: !_vm.passwordEnabled,
                                          type: "radio",
                                        },
                                        domProps: {
                                          checked: _vm._q(
                                            _vm.activeCompanyExternalSetting[
                                              column.value
                                            ],
                                            null
                                          ),
                                        },
                                        on: {
                                          change: function ($event) {
                                            return _vm.$set(
                                              _vm.activeCompanyExternalSetting,
                                              column.value,
                                              null
                                            )
                                          },
                                        },
                                      })
                                    : _c("input", {
                                        directives: [
                                          {
                                            name: "model",
                                            rawName: "v-model",
                                            value:
                                              _vm.activeCompanyExternalSetting[
                                                column.value
                                              ],
                                            expression:
                                              "activeCompanyExternalSetting[column.value]",
                                          },
                                        ],
                                        staticClass: "input",
                                        attrs: {
                                          disabled: !_vm.passwordEnabled,
                                          type: _vm.showPassword
                                            ? "text"
                                            : "password",
                                        },
                                        domProps: {
                                          value:
                                            _vm.activeCompanyExternalSetting[
                                              column.value
                                            ],
                                        },
                                        on: {
                                          input: function ($event) {
                                            if ($event.target.composing) return
                                            _vm.$set(
                                              _vm.activeCompanyExternalSetting,
                                              column.value,
                                              $event.target.value
                                            )
                                          },
                                        },
                                      }),
                                  !_vm.$v.activeCompanyExternalSetting.password
                                    .maxLength
                                    ? _c(
                                        "span",
                                        { staticClass: "help is-danger ml-1" },
                                        [
                                          _vm._v(
                                            "Password must not exceed 50 characters."
                                          ),
                                        ]
                                      )
                                    : _vm._e(),
                                ]
                              ),
                              _c("p", { staticClass: "control" }, [
                                _c(
                                  "button",
                                  {
                                    staticClass: "button",
                                    on: {
                                      click: function ($event) {
                                        _vm.passwordEnabled =
                                          !_vm.passwordEnabled
                                      },
                                    },
                                  },
                                  [_vm._m(1, true)]
                                ),
                              ]),
                              _c("p", { staticClass: "control" }, [
                                _c(
                                  "button",
                                  {
                                    staticClass: "button",
                                    on: {
                                      click: function ($event) {
                                        _vm.showPassword = !_vm.showPassword
                                      },
                                    },
                                  },
                                  [
                                    _c(
                                      "span",
                                      { staticClass: "icon has-text-primary" },
                                      [
                                        _c(
                                          "span",
                                          { staticClass: "mso mso-24px" },
                                          [
                                            _vm._v(
                                              " " +
                                                _vm._s(
                                                  _vm.showPassword
                                                    ? "visibility"
                                                    : "visibility_off"
                                                ) +
                                                " "
                                            ),
                                          ]
                                        ),
                                      ]
                                    ),
                                  ]
                                ),
                              ]),
                            ])
                          : _c("div", { staticClass: "field has-addons" }, [
                              _c(
                                "div",
                                { staticClass: "control is-expanded" },
                                [
                                  _c("input", {
                                    directives: [
                                      {
                                        name: "model",
                                        rawName: "v-model",
                                        value:
                                          _vm.activeCompanyExternalSetting[
                                            column.value
                                          ],
                                        expression:
                                          "activeCompanyExternalSetting[column.value]",
                                      },
                                    ],
                                    staticClass: "input",
                                    attrs: {
                                      type: "text",
                                      disabled:
                                        _vm.requirePasswordGeneration(column) ||
                                        _vm.isDiable(column),
                                    },
                                    domProps: {
                                      value:
                                        _vm.activeCompanyExternalSetting[
                                          column.value
                                        ],
                                    },
                                    on: {
                                      input: function ($event) {
                                        if ($event.target.composing) return
                                        _vm.$set(
                                          _vm.activeCompanyExternalSetting,
                                          column.value,
                                          $event.target.value
                                        )
                                      },
                                    },
                                  }),
                                ]
                              ),
                              _vm.requirePasswordGeneration(column)
                                ? _c("p", { staticClass: "control" }, [
                                    _c(
                                      "button",
                                      {
                                        staticClass: "button is-primary",
                                        on: {
                                          click: function ($event) {
                                            return _vm.randomPassword(32, 6)
                                          },
                                        },
                                      },
                                      [_vm._v(" Generate ")]
                                    ),
                                  ])
                                : _vm._e(),
                            ]),
                      ])
                    }),
                    0
                  ),
                  _c(
                    "div",
                    { staticClass: "column is-half" },
                    _vm._l(
                      _vm.$options.columns.right,
                      function (column, index) {
                        return _c("div", { key: index, staticClass: "field" }, [
                          _c("label", { staticClass: "label" }, [
                            _vm._v(
                              _vm._s(
                                _vm.activeCompanyExternalSetting[column.label]
                              ) + " "
                            ),
                            _vm.isEstimageSettingPage &&
                            _vm.activeCompanyExternalSetting[column.label] ===
                              "Enable Estimage Online"
                              ? _c(
                                  "span",
                                  {
                                    staticClass:
                                      "has-text-weight-normal is-italic is-size-7",
                                  },
                                  [
                                    _vm._v(" ("),
                                    _vm.$userInfo.isSupportUser
                                      ? _c("span", [
                                          _c(
                                            "span",
                                            {
                                              staticClass:
                                                "has-text-weight-bold",
                                            },
                                            [_vm._v("2")]
                                          ),
                                          _vm._v(" = Test, "),
                                        ])
                                      : _vm._e(),
                                    _c(
                                      "span",
                                      { staticClass: "has-text-weight-bold" },
                                      [_vm._v("1")]
                                    ),
                                    _vm._v(" = On and "),
                                    _c(
                                      "span",
                                      { staticClass: "has-text-weight-bold" },
                                      [_vm._v("0")]
                                    ),
                                    _vm._v(" = Off) "),
                                  ]
                                )
                              : _vm._e(),
                            _vm.isEstimageSettingPage &&
                            _vm.activeCompanyExternalSetting[column.label] ===
                              "Auto Sync"
                              ? _c(
                                  "span",
                                  {
                                    staticClass:
                                      "has-text-weight-normal is-italic is-size-7",
                                  },
                                  [
                                    _vm._v(" ("),
                                    _c(
                                      "span",
                                      { staticClass: "has-text-weight-bold" },
                                      [_vm._v("1")]
                                    ),
                                    _vm._v(" = On and "),
                                    _c(
                                      "span",
                                      { staticClass: "has-text-weight-bold" },
                                      [_vm._v("0")]
                                    ),
                                    _vm._v(" = Off) "),
                                  ]
                                )
                              : _vm._e(),
                          ]),
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value:
                                  _vm.activeCompanyExternalSetting[
                                    column.value
                                  ],
                                expression:
                                  "activeCompanyExternalSetting[column.value]",
                              },
                            ],
                            staticClass: "input",
                            attrs: {
                              type: "text",
                              disabled:
                                _vm.requirePasswordGeneration(column) ||
                                _vm.isDiable(column),
                            },
                            domProps: {
                              value:
                                _vm.activeCompanyExternalSetting[column.value],
                            },
                            on: {
                              input: function ($event) {
                                if ($event.target.composing) return
                                _vm.$set(
                                  _vm.activeCompanyExternalSetting,
                                  column.value,
                                  $event.target.value
                                )
                              },
                            },
                          }),
                        ])
                      }
                    ),
                    0
                  ),
                ])
              : _vm._e(),
            _vm.isEstimageSettingPage
              ? _c("div", { staticClass: "columns" }, [
                  _c("div", { staticClass: "column is-half" }, [
                    _c("div", { staticClass: "flex-row" }, [
                      _c("div", { staticClass: "mr-4" }, [
                        _c(
                          "button",
                          {
                            staticClass: "button is-primary",
                            on: {
                              click: function ($event) {
                                return _vm.connectEstimage(false)
                              },
                            },
                          },
                          [
                            _vm._m(2),
                            _c("span", [
                              _vm.activeCompanyExternalSetting.property4 === "1"
                                ? _c("span", [_vm._v("Re-")])
                                : _vm._e(),
                              _vm._v("Connect to Estimage"),
                            ]),
                          ]
                        ),
                        _vm.activeCompanyExternalSetting.property4 === "1"
                          ? _c(
                              "span",
                              { staticClass: "help is-italic has-text-grey" },
                              [
                                _vm._v(
                                  "Last connected: " +
                                    _vm._s(
                                      _vm.$filters.formatDateTimeLocale(
                                        _vm.dateTimeToLocal(
                                          _vm.activeCompanyExternalSetting
                                            .modifiedDate
                                        ),
                                        _vm.$userInfo.locale
                                      )
                                    ) +
                                    " "
                                ),
                              ]
                            )
                          : _vm._e(),
                      ]),
                      _vm.$userInfo.isSupportUser
                        ? _c("div", { staticClass: "mr-4" }, [
                            _c(
                              "button",
                              {
                                staticClass: "button is-primary",
                                on: {
                                  click: function ($event) {
                                    return _vm.connectEstimage(true)
                                  },
                                },
                              },
                              [
                                _vm._m(3),
                                _c("span", [
                                  _vm.activeCompanyExternalSetting.property4 ===
                                  "2"
                                    ? _c("span", [_vm._v("Re-")])
                                    : _vm._e(),
                                  _vm._v("Connect to Test Estimage"),
                                ]),
                              ]
                            ),
                            _vm.activeCompanyExternalSetting.property4 === "2"
                              ? _c(
                                  "span",
                                  {
                                    staticClass: "help is-italic has-text-grey",
                                  },
                                  [
                                    _vm._v(
                                      "Last connected: " +
                                        _vm._s(
                                          _vm.$filters.formatDateTimeLocale(
                                            _vm.dateTimeToLocal(
                                              _vm.activeCompanyExternalSetting
                                                .modifiedDate
                                            ),
                                            _vm.$userInfo.locale
                                          )
                                        ) +
                                        " "
                                    ),
                                  ]
                                )
                              : _vm._e(),
                          ])
                        : _vm._e(),
                    ]),
                  ]),
                  _vm._m(4),
                ])
              : _vm._e(),
          ]),
        ])
      : _c("div", { staticClass: "is-flex is-justify-content-center pt-5" }, [
          _c(
            "div",
            {
              staticClass:
                "notification is-danger is-flex is-justify-content-center is-size-4",
              staticStyle: { width: "50%" },
            },
            [_vm._v(" You do not have permissions on this page ")]
          ),
        ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "column" }, [
      _c("p", { staticClass: "title" }, [_vm._v("Integration")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("span", { staticClass: "icon has-text-primary" }, [
      _c("span", { staticClass: "mso mso-24px" }, [_vm._v("edit")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("span", { staticClass: "icon" }, [
      _c("span", { staticClass: "mso mso-18px" }, [_vm._v("cached")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("span", { staticClass: "icon" }, [
      _c("span", { staticClass: "mso mso-18px" }, [_vm._v("cached")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "div",
      {
        staticClass:
          "column is-half is-flex is-justify-content-right is-align-items-center",
      },
      [
        _c("span", { staticClass: "icon is-small has-text-primary mr-1" }, [
          _c("span", { staticClass: "mso mso-18px" }, [_vm._v("info")]),
        ]),
        _c("span", { staticClass: "help is-primary is-italic" }, [
          _vm._v("Reconnection may periodically be required."),
        ]),
      ]
    )
  },
]
render._withStripped = true

export { render, staticRenderFns }